import React from "react";
import LotSizeField from "./lot-sie-field";
import FilterSubmitButton from "./filter-submit-button";

export default function SizeFiltersTab({
  setOpenDropdown,
  openDropdown,
  register,
  filterData,
  setValue,
  watch,
}) {
  return (
    <>
      <div className="col">
        <div
          className="filter_btn site_btn blank yellow_blank"
          onClick={() =>
            setOpenDropdown(openDropdown === "size" ? null : "size")
          }
        >
          Size
        </div>
        <div
          className={openDropdown === "size" ? "drop_cnt active" : "drop_cnt"}
        >
          <div className="half_flex_outer">
            <div className="form_blk">
              <h6>Total units</h6>
              <div className="half_flex">
                <div className="half_field">
                  <input
                    type="text"
                    name="min_unites"
                    id="min_unites"
                    className="input"
                    placeholder="Min Units"
                    {...register("min_unites")}
                    defaultValue={filterData?.min_unites}
                  />
                </div>
                <span></span>
                <div className="half_field">
                  <input
                    type="text"
                    name="max_unites"
                    id="max_unites"
                    className="input"
                    placeholder="Max Units"
                    {...register("max_unites")}
                    defaultValue={filterData?.max_unites}
                  />
                </div>
              </div>
            </div>
            <div className="form_blk">
              <h6>Building area (SF)</h6>
              <div className="half_flex">
                <div className="half_field">
                  <input
                    type="text"
                    name="min_sf"
                    id="min_sf"
                    className="input"
                    placeholder="Min (SF)"
                    {...register("min_sf")}
                    defaultValue={filterData?.min_sf}
                  />
                </div>
                <span></span>
                <div className="half_field">
                  <input
                    type="text"
                    name="max_sf"
                    id="max_sf"
                    className="input"
                    placeholder="Max (SF)"
                    {...register("max_sf")}
                    defaultValue={filterData?.max_sf}
                  />
                </div>
              </div>
            </div>
            <LotSizeField
              register={register}
              filterData={filterData}
              fieldNamePrefix="size"
              setValue={setValue}
              watch={watch}
            />
            <FilterSubmitButton
              clearStep="size"
              setValue={setValue}
              filterData={filterData}
            />
          </div>
        </div>
      </div>
    </>
  );
}
